import React, {useState, useEffect, useRef} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import Loader from "../components/Loader";
import LoginOverLay from "../components/LoginOverlay";
import {registeredLoginRequest} from "../actions/registeredUserAction";
import {Link} from "react-router-dom";
import Input from "react-validation/build/input";
import RegResetPasswordRequestOverlay from "../components/RegResetPasswordRequestOverlay";

const RegisteredLoginScreen = ({ history }) => {

  // Read the logo from the environment variable, and trim any whitespace.
  // If the environment variable is not set, default to an empty string.
  const logo = (process.env.REACT_APP_PROPERTY_LOGO || "").trim();

  // Initialize react state
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showResetPasswordRequestOverlay, setShowResetPasswordRequestOverlay] = useState(false);
  const form = useRef();
  const dispatch = useDispatch();

  // Modal login overlay for displaying messages to website visitors
  const [showLoginOverlay, setShowLoginOverlay] = useState(process.env.REACT_APP_SHOW_LOGIN_MODAL === 'true');
  const handleClose = () => {
    setShowLoginOverlay(false);
  };

  const handleClosePasswordResetRequestOverlay = () => {
    setShowResetPasswordRequestOverlay(false);
  }

  // Get the loginDetails from the Redux store and destructure the loading and error properties
  const regUserData = useSelector((state) => state.registeredUserDetails);
  const { loginLoading, loginSuccess, loginError } = regUserData;

  useEffect(() => {
    // Only redirect if login succeeded
    if (loginSuccess) {
      history.push(`/homepage`);
    }
  }, [loginSuccess]);

  // Handler for the sign-in button. Dispatches the loginRequest action,
  // which ultimately sends the login request to the server
  const onSubmitHandler = (e) => {
    e.preventDefault();

    if (username && password) {
      dispatch(registeredLoginRequest(username, password));
    }
  };

  return (
    <div className="gcotg-login-top-level">
      <Container fluid>
        <Row>
          <Col className="login-content-box">
            <div>
              <LoginOverLay
                show={showLoginOverlay}
                handleClose={handleClose}
              />
            </div>
            <RegResetPasswordRequestOverlay
              show={showResetPasswordRequestOverlay}
              handleCancel={handleClosePasswordResetRequestOverlay}
            />
            {logo && <img src={logo} alt="Logo" className="main-logo" />}
            {loginLoading && <Loader/>}
            <h2 className="login-screen-title">Digital Gift Card Claims</h2>
            <h4 className="login-screen-subtitle">Registered User Login</h4>
            <p className="login-screen-message">
              {process.env.REACT_APP_LOGIN_MESSAGE}
            </p>
            <Form onSubmit={(e) => onSubmitHandler(e)} ref={form} className="gcotg-form">
              <div>
                <div className="form-group gcotg-form-group">
                  <label htmlFor="username">Email</label>
                  <Form.Control
                    type="text"
                    className="form-control gcotg-form-element"
                    name="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>

                <div className="form-group gcotg-form-group">
                  <label htmlFor="password">Password</label>
                  <Form.Control
                    type="password"
                    className="form-control gcotg-form-element"
                    name="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <a
                    href="#"
                    className="gcotg-forgot-password-link"
                    onClick={(e) => {
                      e.preventDefault();
                      setShowResetPasswordRequestOverlay(true);
                    }}
                  >
                    I forgot my password
                  </a>
                </div>

                <div className="form-group gcotg-form-group">
                  <button className="btn btn-primary btn-block gcotg-button">Log In</button>
                </div>
              </div>
            </Form>
            {loginError && (
              <div className="gcotg-error-message">
                <div role="alert">{loginError}</div>
              </div>
            )}
          </Col>
        </Row>
        <Row>
          <p>
            <span className="registered-login-screen-signup-link">
              Don't have an account? <a href="/userregister">Sign up here</a><br />
            </span>
            <span className="registered-login-screen-guest-link">
              or <a href="/">continue as a guest</a>
            </span>
          </p>
        </Row>
      </Container>
    </div>
  );
};

export default RegisteredLoginScreen;
